var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 11.875C7.49805 11.875 4.9375 9.31445 4.9375 6.125C4.9375 2.98047 7.49805 0.375 10.6875 0.375C13.832 0.375 16.4375 2.98047 16.4375 6.125C16.4375 9.31445 13.832 11.875 10.6875 11.875ZM12.9336 14.0312C17.2461 14.0312 20.75 17.5352 20.75 21.8477C20.75 22.7012 20.0312 23.375 19.1777 23.375H2.15234C1.29883 23.375 0.625 22.7012 0.625 21.8477C0.625 17.5352 4.08398 14.0312 8.39648 14.0312H12.9336ZM28.2969 9.35938C28.8809 9.35938 29.375 9.85352 29.375 10.4375C29.375 11.0664 28.8809 11.5156 28.2969 11.5156H26.1406V13.6719C26.1406 14.3008 25.6465 14.75 25.0625 14.75C24.4336 14.75 23.9844 14.3008 23.9844 13.6719V11.5156H21.8281C21.1992 11.5156 20.75 11.0664 20.75 10.4375C20.75 9.85352 21.1992 9.35938 21.8281 9.35938H23.9844V7.20312C23.9844 6.61914 24.4336 6.125 25.0625 6.125C25.6465 6.125 26.1406 6.61914 26.1406 7.20312V9.35938H28.2969Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlus);
export default __webpack_public_path__ + "static/media/user-plus.be706c57.svg";
export { ForwardRef as ReactComponent };